import { Directive, ElementRef, HostListener, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
@Directive({
  selector: '[appMasker]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaskerDirective),
      multi: true
    }
  ]
})

export class MaskerDirective implements ControlValueAccessor {
  private fullValue = '';
  private onChange: (value: string) => void = () => { };
  private onTouched: () => void = () => { };
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.fullValue = input.value;
    this.onChange(this.fullValue);
  }

  @HostListener('blur')
  onBlur(): void {
    this.el.nativeElement.value = this.formatValue(this.fullValue);
    this.onTouched();
  }


  writeValue(value: string): void {
    this.fullValue = value || '';
    this.el.nativeElement.value = this.formatValue(this.fullValue);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  private formatValue(input: string): string {
    if (!input) return '';
    const visibleLength = 4;
    const maskedLength = Math.max(0, input.length - visibleLength);
    const maskedPart = 'X'.repeat(maskedLength);
    const visiblePart = input.slice(-visibleLength);
    return maskedPart + visiblePart;
  }
}